import React, { useState } from 'react';
import { UIFlagsModal } from './UIFlagsModal';

export const useUIFlagsModal = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  const modal = <UIFlagsModal open={open} onClose={toggle} />;
  return [toggle, modal];
};
